var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41675 5.66667C1.41675 4.88426 2.05101 4.25 2.83341 4.25H31.1667C31.9491 4.25 32.5834 4.88426 32.5834 5.66667V31.1667C32.5834 31.9491 31.9491 32.5833 31.1667 32.5833H2.83341C2.05101 32.5833 1.41675 31.9491 1.41675 31.1667V5.66667ZM4.25008 7.08333V29.75H29.7501V7.08333H4.25008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91683 2.83331V7.79165H7.0835V2.83331H9.91683Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9168 2.83331V7.79165H24.0835V2.83331H26.9168Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8335 9.91663H31.1668V12.75H2.8335V9.91663Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8317 14.5816C19.3691 14.0441 20.2348 14.0266 20.7936 14.5417L23.627 17.1537C23.9082 17.413 24.0727 17.775 24.0829 18.1574C24.0931 18.5398 23.9483 18.9101 23.6813 19.1841L16.0153 27.0496C15.2154 27.8704 14.1179 28.3333 12.9718 28.3333H11.3334C10.551 28.3333 9.91675 27.699 9.91675 26.9166V25.2569C9.91675 24.1297 10.3645 23.0487 11.1615 22.2517L18.8317 14.5816ZM19.8733 17.5469L13.165 24.2552C12.8993 24.5208 12.7501 24.8812 12.7501 25.2569V25.5H12.9718C13.3538 25.5 13.7196 25.3457 13.9863 25.0721L20.6356 18.2496L19.8733 17.5469Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCalendar);
export default __webpack_public_path__ + "static/media/edit-calendar.4aeaee567578bfee1815fc69edeea510.svg";
export { ForwardRef as ReactComponent };